// src/Admin/AdminRouter.js
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AdminLayout from "./AdminLayout";
import AdminDashboard from "./AdminDashboard";

// Admin pages (we’ll create these next)
import AdminOrders from "./pages/AdminOrders";
import AdminOrderDetails from "./pages/AdminOrderDetails";
import AdminPayments from "./pages/AdminPayments";
import AdminRefunds from "./pages/AdminRefunds";
import AdminPayouts from "./pages/AdminPayouts";
import AdminSupport from "./pages/AdminSupport";
import AdminDisputes from "./pages/AdminDisputes";
import AdminCustomers from "./pages/AdminCustomers";
import AdminCouriers from "./pages/AdminCouriers";
import AdminSettings from "./pages/AdminSettings";

export default function AdminRouter() {
  return (
    <AdminLayout>
      <Switch>
        <Route path="/admin/dashboard" exact component={AdminDashboard} />

        <Route path="/admin/orders" exact component={AdminOrders} />
        <Route path="/admin/orders/:orderId" exact component={AdminOrderDetails} />

        <Route path="/admin/payments" exact component={AdminPayments} />
        <Route path="/admin/payments/refunds" exact component={AdminRefunds} />
        <Route path="/admin/payments/payouts" exact component={AdminPayouts} />

        <Route path="/admin/support" exact component={AdminSupport} />
        // ✅ make disputes route render AdminSupport
        <Route path="/admin/support/disputes" exact component={AdminSupport} />



        <Route
           path="/admin/users"
           exact
           render={() => <Redirect to="/admin/users/customers" />}
        />
        <Route path="/admin/users/customers" exact component={AdminCustomers} />
        <Route path="/admin/users/couriers" exact component={AdminCouriers} />

        <Route path="/admin/settings" exact component={AdminSettings} />
        <Route path="/admin/settings/pricing" exact component={AdminSettings} />
        <Route path="/admin/settings/promos" exact component={AdminSettings} />

        {/* Default */}
        <Route path="/admin" exact render={() => <Redirect to="/admin/dashboard" />} />
      </Switch>
    </AdminLayout>
  );
}
